// Carte produit SNK (snippets/card-product.liquid, snippets/snk-quick-add.liquid) : ajout rapide.
// Ordi (≥ 990 px, pointeur), « option A » : sous le prix, les pointures en liens vers la fiche (?variant=ID), 4 au plus
// puis « +N » qui déplie toutes les pointures dans la carte (« Moins » les replie, Échap aussi). Le bouton rond « + » en bas à droite de la photo ouvre une petite fenêtre
// de tailles ancrée au bouton (.snk-qa) : clic dehors, Échap ou le bouton la ferment, le focus y est piégé ; un clic sur
// une taille l'ajoute, le bouton passe 1,6 s en « ✓ », puis le tiroir panier s'ouvre. Le nom est limité à 2 lignes : la
// police baisse avant les « … ».
// Tablette (750 à 989 px) : « + Ajouter » déroule le tiroir des tailles sous la photo (le « + » pivote en « × ») ; un
// clic sur une taille l'ajoute, le tiroir se referme, le bouton passe 1,6 s en « ✓ Ajouté », puis le tiroir panier.
// Mobile : feuille depuis le bas (<dialog> : focus piégé, Échap et voile ferment) ; la taille choisie active le
// bouton « Ajouter au panier · prix », puis « Ajouté ✓ » et le tiroir panier.
// Ajout par l'Ajax API, comme product-form.js de Dawn. Pas d'animation si prefers-reduced-motion.
if (!customElements.get('snk-card')) {
  const SHEET_MS = 400;
  const ADDED_MS = 1600;

  customElements.define(
    'snk-card',
    class SnkCard extends HTMLElement {
      connectedCallback() {
        this.setupFit();
        this.button = this.querySelector('.snk-card__add');
        this.band = this.querySelector('[data-snk-sizes]');
        if (this.band) this.setupBand();
        if (!this.button) return;
        this.drawer = this.querySelector('.snk-qa');
        this.sizes = this.querySelector('[data-snk-qa-sizes]');
        this.sheet = this.querySelector('.snk-qa-sheet');
        this.message = this.querySelector('.snk-card__qa-message');
        this.label = this.button?.querySelector('.snk-card__add-label');
        // Carte « Complète ta commande » (data-upsell) : toujours la feuille, le tiroir déroulant n'y tient pas
        this.desktop = this.hasAttribute('data-upsell') ? { matches: false, addEventListener() {} } : window.matchMedia('(min-width: 750px)');
        // Ordi avec pointeur : le panneau est une fenêtre ancrée au bouton rond (clic dehors, Échap, focus piégé).
        // (« popover » est un nom réservé des éléments HTML : ne pas l'utiliser comme propriété)
        this.anchored = this.hasAttribute('data-upsell') ? { matches: false } : window.matchMedia('(hover: hover) and (min-width: 990px)');

        if (!this.drawer) {
          this.button?.addEventListener('click', () => this.add(this.button.dataset.variantId, this.button));
          return;
        }

        this.button?.addEventListener('click', () => {
          if (this.desktop.matches) this.toggleDrawer();
          else this.openSheet();
        });
        this.sizes.addEventListener('click', (event) => {
          const size = event.target.closest('.snk-qa__size');
          if (size && !size.disabled) this.choose(size);
        });
        this.drawer.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.closeDrawer();
            this.button.focus();
            return;
          }
          if (event.key === 'Tab' && this.anchored.matches) this.trapFocus(event);
        });
        // Fenêtre ancrée : un clic hors de la carte la ferme
        this.onDocumentClick = (event) => {
          if (!this.classList.contains('is-open') || !this.anchored.matches) return;
          if (this.drawer.contains(event.target) || this.button.contains(event.target)) return;
          this.closeDrawer();
        };

        this.cta = this.sheet.querySelector('.snk-qa-sheet__cta');
        this.cta.addEventListener('click', () => this.add(this.selected?.dataset.variantId, this.cta));
        this.sheet.querySelector('[data-snk-qa-close]').addEventListener('click', () => this.closeSheet());
        this.sheet.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closeSheet();
        });
        // Clic sur le voile, hors de la feuille
        this.sheet.addEventListener('click', (event) => {
          if (event.target === this.sheet && event.clientY < this.sheet.getBoundingClientRect().top) this.closeSheet();
        });
        this.sheet.addEventListener('close', () => {
          this.sheet.classList.remove('is-visible');
          this.drawer.querySelector('.snk-qa__inner').append(this.sizes);
          this.reset();
        });
        // Passage mobile ↔ ordi : on referme tout
        this.desktop.addEventListener('change', () => {
          this.closeDrawer();
          if (this.sheet.open) this.sheet.close();
        });
      }

      get reducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      // ===== Ajustements au chargement et au redimensionnement : ligne de prix, badge de période =====
      // (le nom a une structure fixe en CSS : 2 lignes de hauteur fixe, « … » par ligne, rien à mesurer)

      setupFit() {
        this.priceLine = this.querySelector('.snk-card__price');
        this.period = this.querySelector('.snk-card__period');
        if (!this.priceLine && !this.period) return;
        const fit = () => {
          this.fitPrice();
          this.fitPeriod();
        };
        if ('ResizeObserver' in window) new ResizeObserver(fit).observe(this);
        document.fonts?.ready.then(fit);
        fit();
      }

      // Badge de période sur une seule ligne : la police baisse (jusqu'à 8 px) s'il déborde de la photo, et il
      // remonte juste au-dessus du bouton « + » s'il le toucherait (cartes étroites, textes longs)
      fitPeriod() {
        const badge = this.period;
        if (!badge) return;
        badge.style.fontSize = '';
        badge.style.bottom = '';
        let size = parseFloat(getComputedStyle(badge).fontSize);
        while (badge.scrollWidth > badge.clientWidth && size > 8) {
          size -= 0.5;
          badge.style.fontSize = `${size}px`;
        }
        const button = this.querySelector('.snk-card__add');
        const media = this.querySelector('.snk-card__media');
        if (!button || !media || !button.clientWidth) return;
        const b = button.getBoundingClientRect();
        const p = badge.getBoundingClientRect();
        if (p.right > b.left - 6 && p.bottom > b.top) {
          badge.style.bottom = `${Math.round(media.getBoundingClientRect().bottom - b.top) + 6}px`;
        }
      }

      // Prix sur une seule ligne, jamais coupé : la police de la ligne (barré + prix) baisse jusqu'à 11 px si elle
      // déborde de la carte (cartes étroites, « dès 129,90 € » avec un prix barré)
      fitPrice() {
        const line = this.priceLine;
        if (!line || !line.clientWidth) return;
        line.style.fontSize = '';
        let size = parseFloat(getComputedStyle(line).fontSize);
        while (line.scrollWidth > line.clientWidth && size > 11) {
          size -= 0.5;
          line.style.fontSize = `${size}px`;
        }
      }

      // ===== Ordi : ligne des pointures sous le prix (liens vers la fiche, « +N » / « Moins ») =====

      setupBand() {
        this.more = this.band.querySelector('.snk-card__size-more');
        this.bandList = this.band.querySelector('.snk-card__sizes-list');
        this.bandItems = [...this.band.querySelectorAll('.snk-card__size-item')];
        if (!this.more || !this.bandList) return;
        this.more.addEventListener('click', () => this.toggleSizes());
        // Souris : survol de « +N » = grille dépliée ; la souris sort de la grille = repli animé (LG, 2 nov. 2026).
        // Petit délai à la sortie, annulé si la souris revient : pas de clignotement en frôlant le bord.
        if (window.matchMedia('(hover: hover)').matches) {
          this.more.addEventListener('pointerenter', () => {
            clearTimeout(this.leaveTimer);
            if (!this.band.classList.contains('is-open') || this.band.classList.contains('is-closing')) this.toggleSizes(true);
          });
          this.band.addEventListener('pointerenter', () => clearTimeout(this.leaveTimer));
          this.band.addEventListener('pointerleave', () => {
            if (!this.band.classList.contains('is-open')) return;
            this.leaveTimer = setTimeout(() => this.toggleSizes(false), 150);
          });
        }
        this.band.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !this.band.classList.contains('is-open')) return;
          this.toggleSizes(false);
          this.more.focus();
        });
        const fit = () => this.fitBand();
        if ('ResizeObserver' in window) new ResizeObserver(fit).observe(this.band);
        else window.addEventListener('resize', fit);
        document.fonts?.ready.then(fit);
        fit();
      }

      // 4 pointures au plus sur la ligne, moins si la carte est étroite (jamais de pointure coupée) ; le reste est
      // compté dans « +N »
      fitBand() {
        if (this.band.classList.contains('is-open') || !this.bandList.clientWidth) return;
        this.bandItems.forEach((item, i) => (item.hidden = i >= 4));
        this.more.hidden = this.bandItems.length <= 4;
        for (let shown = Math.min(4, this.bandItems.length); shown > 1 && this.bandList.scrollWidth > this.bandList.clientWidth; shown--) {
          this.bandItems[shown - 1].hidden = true;
          this.more.hidden = false;
        }
        this.hiddenCount = this.bandItems.filter((item) => item.hidden).length;
        this.labelMore();
      }

      labelMore() {
        const count = String(this.hiddenCount ?? 0);
        const open = this.band.classList.contains('is-open');
        this.more.textContent = open ? this.more.dataset.less : this.more.dataset.more.replace('%n', count);
        if (open) this.more.removeAttribute('aria-label');
        else this.more.setAttribute('aria-label', this.more.dataset.moreLabel.replace('%n', count));
      }

      // Toutes les pointures dans la carte, sur plusieurs lignes, par-dessus le haut de la carte (hauteur inchangée)
      toggleSizes(force) {
        const open = force ?? (!this.band.classList.contains('is-open') || this.band.classList.contains('is-closing'));
        // Repli : même animation à l'envers (classe is-closing, snk-card.css), puis fermeture réelle
        if (!open && this.band.classList.contains('is-open') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          if (this.band.classList.contains('is-closing')) return;
          this.band.classList.add('is-closing');
          clearTimeout(this.closeTimer);
          this.closeTimer = setTimeout(() => {
            this.band.classList.remove('is-closing');
            this.closeSizes();
          }, 220);
          return;
        }
        clearTimeout(this.closeTimer);
        this.band.classList.remove('is-closing');
        if (!open) {
          this.closeSizes();
          return;
        }
        this.openSizes();
      }

      openSizes() {
        this.band.classList.add('is-open');
        this.more.setAttribute('aria-expanded', 'true');
        this.bandItems.forEach((item) => (item.hidden = false));
        this.labelMore();
        // Clic en dehors de la grille (ailleurs dans la page, ou sur une autre carte) : elle se referme (LG, 2 nov. 2026)
        if (!this.onOutside) {
          this.onOutside = (event) => {
            if (!this.band.contains(event.target)) this.toggleSizes(false);
          };
          document.addEventListener('pointerdown', this.onOutside, true);
        }
      }

      closeSizes() {
        this.band.classList.remove('is-open');
        this.more.setAttribute('aria-expanded', 'false');
        this.fitBand();
        if (this.onOutside) {
          document.removeEventListener('pointerdown', this.onOutside, true);
          this.onOutside = null;
        }
      }

      // ===== Panneau des tailles : fenêtre ancrée au bouton rond (ordi), tiroir sous la photo (tablette) =====

      // Tab et Maj+Tab restent dans la fenêtre (tailles disponibles et lien du guide)
      trapFocus(event) {
        const focusable = [...this.drawer.querySelectorAll('button:not(:disabled), a[href]')];
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      toggleDrawer() {
        if (this.classList.contains('is-open')) this.closeDrawer();
        else this.openDrawer();
      }

      openDrawer() {
        this.reset();
        this.classList.add('is-open');
        this.drawer.inert = false;
        this.button.setAttribute('aria-expanded', 'true');
        this.sizes.querySelector('.snk-qa__size:not(:disabled)')?.focus({ preventScroll: true });
        document.addEventListener('click', this.onDocumentClick);
      }

      closeDrawer() {
        this.classList.remove('is-open');
        this.drawer.inert = true;
        this.button.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', this.onDocumentClick);
      }

      // ===== Mobile : feuille depuis le bas =====

      openSheet() {
        this.reset();
        this.sheet.querySelector('[data-snk-qa-slot]').append(this.sizes);
        this.sheet.showModal();
        this.button.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => this.sheet.classList.add('is-visible'));
      }

      closeSheet() {
        if (!this.sheet.open) return;
        this.sheet.classList.remove('is-visible');
        this.button.setAttribute('aria-expanded', 'false');
        setTimeout(() => this.sheet.close(), this.reducedMotion ? 0 : SHEET_MS);
      }

      // ===== Tailles et ajout =====

      reset() {
        this.selected = null;
        this.sizes?.querySelectorAll('[aria-pressed="true"]').forEach((size) => size.setAttribute('aria-pressed', 'false'));
        if (this.cta) {
          this.cta.disabled = true;
          this.cta.classList.remove('is-added');
          this.cta.textContent = this.cta.dataset.chooseLabel;
        }
        this.message.textContent = '';
      }

      choose(size) {
        this.sizes.querySelectorAll('[aria-pressed="true"]').forEach((other) => other.setAttribute('aria-pressed', 'false'));
        size.setAttribute('aria-pressed', 'true');
        this.selected = size;
        if (this.desktop.matches) {
          this.add(size.dataset.variantId, size);
          return;
        }
        this.cta.disabled = false;
        this.cta.textContent = this.cta.dataset.addLabel.replace('[price]', size.dataset.price);
      }

      add(variantId, trigger) {
        if (!variantId || trigger.getAttribute('aria-busy') === 'true') return;
        trigger.setAttribute('aria-busy', 'true');
        this.message.textContent = '';

        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        // « Complète ta commande » (carte 49) : la ligne porte _upsell, puis le code -15 % est appliqué
        if (this.hasAttribute('data-upsell')) formData.append('properties[_upsell]', '1');
        if (cart) {
          formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(trigger);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.message.textContent = response.description || response.message;
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'snk-card',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              return;
            }
            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'snk-card', productVariantId: variantId, cartData: response });
            const upsell = this.hasAttribute('data-upsell') && window.snkCartUpsell;
            this.added(trigger, async () => {
              let final = response;
              if (upsell) {
                try {
                  final = await upsell.applyAfterAdd(response);
                } catch (error) {
                  console.error('Code -15 % non appliqué :', error);
                }
              }
              cart.renderContents(final);
              if (upsell) setTimeout(() => upsell.afterRender(final));
            });
          })
          .catch((error) => {
            console.error(error);
            this.message.textContent = window.cartStrings?.error || '';
          })
          .finally(() => trigger.removeAttribute('aria-busy'));
      }

      // « ✓ Ajouté » (bouton ou feuille), puis le tiroir panier
      added(trigger, openCart) {
        if (trigger === this.cta) {
          this.cta.classList.add('is-added');
          this.cta.textContent = this.cta.dataset.addedLabel;
          setTimeout(() => {
            this.closeSheet();
            setTimeout(openCart, this.reducedMotion ? 0 : SHEET_MS);
          }, ADDED_MS);
          return;
        }
        if (this.drawer) this.closeDrawer();
        const label = this.label.textContent;
        this.button.classList.add('is-added');
        this.label.textContent = this.button.dataset.addedLabel;
        setTimeout(() => {
          this.button.classList.remove('is-added');
          this.label.textContent = label;
          openCart();
        }, ADDED_MS);
      }
    }
  );
}
